import React from 'react';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useChooseTheWayPageStore } from 'store/pages/proposal-generation/chooseTheWayPageStore';
import ProposalGenerationStepHeader from '../../ProposalGenerationStepHeader';
import {
  FIRST_STEP_TEST_ID,
  UPLOAD_OPTION_RADIO_GROUP_TEST_ID,
  STANDARD_FLOW_RADIO_OPTION_TEST_ID,
  CUSTOM_FILE_RADIO_OPTION_TEST_ID,
} from '../constants';
import { RadioGroupWrapperStyled } from './styles';

const radioButtons = [
  {
    label: 'No, I want to use the standard generation flow',
    value: 'standard-flow',
    id: 'standard-flow',
    key: 'standard-flow',
    'data-test-id': STANDARD_FLOW_RADIO_OPTION_TEST_ID,
  },
  {
    label: 'Yes, I want to upload my own proposal file',
    value: 'custom-file',
    id: 'custom-file',
    key: 'custom-file',
    'data-test-id': CUSTOM_FILE_RADIO_OPTION_TEST_ID,
  },
];

const FirstStep: React.FC = observer(() => {
  const {
    firstStepController: { uploadOption, setUploadOption },
  } = useChooseTheWayPageStore();

  const handleRadioGroupChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setUploadOption(e.target.value as 'standard-flow' | 'custom-file');
  };

  return (
    <section data-test-id={FIRST_STEP_TEST_ID}>
      <ProposalGenerationStepHeader
        title="Upload Custom Proposal File"
        info="Do you want to upload your own proposal file or use the standard generation flow?"
      />
      <RadioGroupWrapperStyled>
        <RadioGroup
          value={uploadOption}
          onChange={handleRadioGroupChange}
          radioButtons={radioButtons}
          data-test-id={UPLOAD_OPTION_RADIO_GROUP_TEST_ID}
        />
      </RadioGroupWrapperStyled>
    </section>
  );
});

export default FirstStep;
